import ImagePlaceholder from "../../../../components/Placeholders/ImagePlaceholder";
import timePlaceholder from '../../../../assets/Images/wait.png'

import './TransactionDialog.css';

const TransactionDialog = ({ onClose, partId }) => {
  return (
    <div className="transaction-dialog-component">
      <div className="header-dialog">
        <b>Detailed Transaction History</b>
        <button onClick={onClose} className="outlined icon">
          <i className="icon-cross"></i>
        </button>
      </div>
      <ImagePlaceholder image={timePlaceholder} title={"We are working on this section."} subtitle={""} />


    </div>)
}

export default TransactionDialog;